module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pay-result"
  }, [_c('p', [_vm._v("订单号：" + _vm._s(_vm.payResult && _vm.payResult.orderNo))]), _vm._v(" "), _c('p', [_vm._v("支付方式："), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.payResult && _vm.payResult.payTypeName))])]), _vm._v(" "), _c('p', [_vm._v("订单金额："), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.payResult && _vm.payResult.payAmount))])])]), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [(_vm.payResult.orderFlag == 2) ? _c('mu-raised-button', {
    staticClass: "full gray",
    attrs: {
      "fullWidth": "",
      "label": "查看订单详情"
    },
    on: {
      "click": _vm.gotoOrderDetail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payResult.orderFlag == 1) ? _c('mu-raised-button', {
    staticClass: "full gray",
    attrs: {
      "fullWidth": "",
      "label": "查看订单"
    },
    on: {
      "click": _vm.gotoOrder
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full",
    attrs: {
      "label": "继续逛逛",
      "fullWidth": ""
    },
    on: {
      "click": _vm.goScanmore
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-result-box"
  }, [_c('p', [_vm._v("订单支付成功！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119d46e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/paysuccess.vue
// module id = 375
// module chunks = 68